module.exports = __webpack_public_path__ + "static/media/download-gray.1c805eb4.svg";